<div class="tabWrapper">
    <ul>
        <li [routerLink]="tab.state" routerLinkActive="active" [routerLinkActiveOptions]="{exact:
            true}" *ngFor="let tab of profileTab" class="tabHead">
            <a class="tab-item" id="navitem-{{tab.id}}" attr.aria-label="Go to {{tab.name}}" >{{tab.name}}</a>
        </li>
    </ul>
</div>
